import { useEffect, useState } from 'react';
import { BaseUrl } from '../api';

interface User {
  id: number;
  username: string;
  email: string;
  is_staff: boolean;
}

const useCheckAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<User | null>(
    JSON.parse(localStorage.getItem('token') || '{}')
  );

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await fetch(`${BaseUrl}/check-auth/`, {
          credentials: 'include',
        });
        const data = await response.json();

        if (JSON.parse(localStorage.getItem('token') || '')) {
          setIsLoggedIn(true);
          setUser(JSON.parse(localStorage.getItem('token') || '{}'));
        } else {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  return { isLoggedIn, isLoading, user };
};

export default useCheckAuth;
